<template lang="pug">
#bloco-totalizador-monitoramento-socioambiental(
    element-loading-background='rgb(255 255 255 / 0%)'
)
    transition(name='el-fade-in-linear')
        .bloco-totalizador-monitoramento-socioambiental-container
            h3 Totalizadores
            .bloco-totalizador-monitoramento-socioambiental__bloco(
                v-loading='carregando'
            )
                BaseBlocoTotalizador(
                    v-for='(resultado, index) in resultados',
                    :key='resultado.valor + index',
                    :texto='resultado.texto',
                    :numero='resultado.valor'
                )
                    template(slot='icone')
                        i(:class='resultado.classe')
</template>

<script>
import BaseBlocoTotalizador from '@/components/monitoramento/BaseBlocoTotalizador';
// import constantes from '@/utils/constantes';
import AreasMonitoradasService from '@/services/AreasMonitoradasService';

export default {
    name: 'BlocoTotalizadorMonitoramentoSocioambiental',
    props: {
        filtros: {
            type: Object,
            default: () => {}
        },
        areasMonitoradas: {
            type: Object,
            default: () => null
        }
    },
    components: {
        BaseBlocoTotalizador
    },
    data() {
        return {
            resultados: [],
            carregando: true,
            paginacao: {
                tamanho: null,
                pagina: null,
                ordenacao: null
            }
        };
    },

    async mounted() {
        await this.buscarTotalizadores();
    },
    watch: {
        filtros() {
            this.buscarTotalizadores();
        }
    },
    methods: {
        async buscarTotalizadores() {
            try {
                this.carregando = true;
                const { data } =
                    await AreasMonitoradasService.buscarTotalizadoresMonitoradasSocioambiental(
                        this.filtros,
                        this.paginacao
                    );
                this.resultados = data;
                this.carregando = false;
            } catch {
                this.$notify.error({
                    message:
                        'Ocorreu um erro ao buscar os totalizadores das áreas monitoradas'
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-totalizador-monitoramento-socioambiental {
    min-height: 122.2px;

    .bloco-totalizador-monitoramento-socioambiental-container {
        h3 {
            margin-bottom: 10px;
            color: var(--black);
            font-weight: 500;
        }
        .bloco-totalizador-monitoramento-socioambiental__bloco {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
        }
    }
}
</style>
